/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import BaseCom from "./BaseCom";
import Icon from "./Icon";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";

class Rating extends BaseCom {
    render() {
        if(this.props.hideWhenZero && this.props.rating === 0)
            return null;

        var content = [];

        for (var n = 1; n <= 3; n++) {
            const r = n;
            content.push(<span key={n} className={(this.props.small ? 'small ' : 'fs-2 ') + (this.props.rating >= n ? 'text-warning' : 'text-secondary')} role={this.props.onChange ? 'button' : null}
                style={{whiteSpace: 'nowrap', fontSize: (this.props.small ? '0.7rem' : null)}}
                onClick={this.props.onChange ? () => this.props.onChange(r) : null}><Icon icon="faStar" /></span>);
        }

        if(this.props.reset) {
            content.splice(0,0,<span role="button" className={'text-secondary' + (this.props.small ? '' : ' fs-2')} onClick={this.props.onChange ? () => this.props.onChange(0) : null}><Icon icon="faCancel" /> </span>);
        }

        return <>
            <div className={'rating' + (this.props.small ? ' text-center' : '')} style={{minWidth: '40px'}}>{content}</div>
            {!this.props.brief ? <small className="d-block">{this.props.rating >= 3 ? 'Awesome!' : this.props.rating >= 2 ? 'Good' : this.props.rating !== 0 ? 'Stale' : 'Unrated'}</small> : null}
        </>;
    }
}

export default withParamsAndNavigate(Rating);